/** @format */

import React, {useState} from 'react';
import {useSave} from '../../../components/form/use_save';

export function useOrderArchive(orderId, onArchive, onUnarchive) {
    const [isSaved, setIsSaved] = useState(false);

    // I archive or un-archive the given order Id based on the status passed to me
    const {save, isSaving, error} = useSave('/account/orders/archiveUnArchive/' + orderId, 0);

    const handleUnarchive = async () => {
        await save({is_archiving: false});
        setIsSaved(true);
        onUnarchive();
    };

    const handleArchive = async () => {
        await save({is_archiving: true});
        setIsSaved(true);
        onArchive();
    };

    return {
        handleUnarchive,
        handleArchive,
        isSaving,
        isSaved,
        error
    };
}
